var $535c41866ee7cefd$exports = {};
$535c41866ee7cefd$exports = {
    "collectionLabel": `N\xe1vrhy`
};


export {$535c41866ee7cefd$exports as default};
//# sourceMappingURL=sk-SK.mjs.map
